/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Model_Download_On_First_UseInputs */

const en_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model will be downloaded on first use`)
};

const fr_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le modèle sera téléchargé lors de la première utilisation`)
};

const de_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Modell wird bei der ersten Verwendung heruntergeladen`)
};

const it_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il modello verrà scaricato al primo utilizzo`)
};

const ru_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модель будет загружена при первом использовании`)
};

const es_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El modelo se descargará en el primer uso`)
};

const zh_cn2_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型将在首次使用时下载`)
};

const ja_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モデルは初回利用時にダウンロードされます`)
};

const hi_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहली बार उपयोग पर मॉडल डाउनलोड किया जाएगा`)
};

const pt_pt2_offline_sync_model_download_on_first_use = /** @type {(inputs: Offline_Sync_Model_Download_On_First_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O modelo será transferido na primeira utilização`)
};

/**
* | output |
* | --- |
* | "Model will be downloaded on first use" |
*
* @param {Offline_Sync_Model_Download_On_First_UseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_model_download_on_first_use = /** @type {((inputs?: Offline_Sync_Model_Download_On_First_UseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Model_Download_On_First_UseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_model_download_on_first_use(inputs)
	if (locale === "de") return de_offline_sync_model_download_on_first_use(inputs)
	if (locale === "it") return it_offline_sync_model_download_on_first_use(inputs)
	if (locale === "ru") return ru_offline_sync_model_download_on_first_use(inputs)
	if (locale === "es") return es_offline_sync_model_download_on_first_use(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_model_download_on_first_use(inputs)
	if (locale === "ja") return ja_offline_sync_model_download_on_first_use(inputs)
	if (locale === "hi") return hi_offline_sync_model_download_on_first_use(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_model_download_on_first_use(inputs)
	return en_offline_sync_model_download_on_first_use(inputs)
});